import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'
import { Field, FormikProvider, useFormik } from 'formik'
import CustomInput from '../../../components/common/CustomInput'
import * as Yup from 'yup'

const validationSchema = Yup.object({
  name: Yup.string().trim().required('Name is required'),
})

function Edit() {
  const navigate = useNavigate()
  const { id } = useParams()
  const [loading, setLoading] = useState(true)

  const formik = useFormik({
    onSubmit: (values, formikHelpers) => handleSubmit(values, formikHelpers),
    validationSchema,
    initialValues: {
      name: '',
    },
  })

  const fetchData = async () => {
    try {
      const response = await axiosAuthInstance.get(`material/detail/${id}`)
      formik.setValues({
        name: response.data.result.name,
      })
      setLoading(false)
    } catch (error) {
      console.log('error in fetching edit data: ', error)
    }
  }

  useEffect(() => {
    fetchData()
  }, [id])

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const response = await axiosAuthInstance.put(`material/update/${id}`, {
        name: values.name,
      })
      if (response) {
        navigate('/material')
      }
    } catch (error) {
      console.log(error)
    }
  }

  if (loading) {
    return <div>Loading...</div>
  }

  return (
    <FormikProvider value={formik}>
      <form
        className='flex flex-col p-4 gap-4'
        onSubmit={(e) => {
          e.preventDefault()
          formik.handleSubmit()
        }}
      >
        <Field
          name='name'
          label='Name'
          placeholder='Enter Name'
          required
          component={CustomInput}
        />

        <button
          type='submit'
          disabled={formik.isSubmitting}
          className='bg-primary text-xl font-medium text-white rounded-lg px-6 py-2'
        >
          Update
        </button>
      </form>
    </FormikProvider>
  )
}

export default Edit
